<wuc-button type="clean" e2e="modal_close" modal-close-btn>
    <wuc-icon-ui icon="cross-closed"></wuc-icon-ui>
</wuc-button>

<h2 modal-title>{{ factorDescription }} annuleren</h2>
<div modal-content class="modal-body">
    <p>Weet u zeker dat u deze {{ factorDescription | lowercase }} wilt annuleren?</p>
</div>

<wuc-balloon backgroundStyle="secondary" padding="medium" [hasCloseIcon]="false" *ngIf="errors?.length">
    <wuc-list icon="cross">
        <ng-container *ngFor="let error of errors">
            <wuc-list-item>{{ error.message }}</wuc-list-item>
        </ng-container>
    </wuc-list>
</wuc-balloon>


<div class="btn-group btn-group--spread insurance-cancel-added-premium-determining-factor__button-group">
    <wuc-link type="secondary" (clicked)="close()">Nee, toch niet</wuc-link>
    <wuc-button type="primary" [disabled]="isDisabled" (buttonClick)="onCancelAddedPremiumDeterminingFactor()">Ja, {{ factorDescription | lowercase }} annuleren</wuc-button>
</div>
